<template>
  <div class="box">
    <div class="up">
      <div class="item bg-color-black">
        <div class="d-flex pt-2 pl-2">
        <span>
          <icon name="chart-line" class="text-icon"></icon>
        </span>
          <div class="d-flex">
            <span class="fs-xl text mx-2">体检次数排行榜</span>
          </div>
        </div>
        <div class="d-flex jc-center body-box">
<!--          <BottomLeftChart/>-->
          <Chart :cdata="cdata" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from '_c/echart/bottom/bottomLeftChart/chart.vue'
import {getTimeType} from "@/api/area/right2";
export default {
  components: {
    // BottomLeftChart
    Chart,
  },
  data () {

    return {
      cdata: {
        category: [
          "身高体重",
          "血压",
          "血脂",
          "血糖",
          "血氧",
          "胆固醇",
          "血红蛋白",
          "体温",
          "心电",
          "人体成分",
          "尿酸"
        ],
        lineData: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        // barData: [
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0,
        //   0
        // ],
        rateData: []
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      // 体检次数排行榜
      getTimeType().then((res) => {
        if (res.code === "0") {
          // let ret = [];
          // res.data.forEach((item) => {
          //   ret.push([item.username, item.cstamp, "<span  class='colorRed'>" + item.time + "</span>"],);
          // });
          // this.config.data = ret;
          // this.config = {...this.config}
          // this.cdata.lineData

          res.data.forEach((item) => {
           if (item.type === 3){
             this.cdata.lineData[0] = item.time;
           }else if (item.type === 7){
             this.cdata.lineData[1] = item.time;
           }else if (item.type === 29){
             this.cdata.lineData[2] = item.time;
           }else if (item.type === 6){
             this.cdata.lineData[3] = item.time;
           }else if (item.type === 5){
             this.cdata.lineData[4] = item.time;
           }else if (item.type === 13){
             this.cdata.lineData[5] = item.time;
           }else if (item.type === 36){
             this.cdata.lineData[6] = item.time;
           }else if (item.type === 3){
             this.cdata.lineData[7] = item.time;
           }else if (item.type === 4){
             this.cdata.lineData[8] = item.time;
           }else if (item.type === 8){
             this.cdata.lineData[9] = item.time;
           }else if (item.type === 15){
             this.cdata.lineData[10] = item.time;
           }
          });

          this.cdata = {...this.cdata}
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/box';

.item {
  width: 100%;
  height: 100%;
}

.text {
  color: #c3cbde;
}

.body-box {
  border-radius: 10px;
  overflow: hidden;
  Chart {
    height: 100%;
  }
}
</style>
